import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Dialog } from '@dojo/widgets/dialog';
import Button from '@dojo/widgets/button';
import { createNlsMiddleware, registry, landingChange, documentapi } from 'lcc-state';
import { ResourceParser } from '@holmescorp/resource-parser';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/general.m.css';
const nls = createNlsMiddleware('landing');
const factory = create({
    theme,
    nls,
    documentapi
}).properties();
export const GeneralLandingPage = factory(({ properties, middleware: { theme, nls, documentapi } }) => {
    const { useDialog = false, useResourceParsing = true } = properties();
    const themeCss = theme.classes(css);
    const { messages: { general_content = '[]', general_complete_button = 'Continue', general_a11y_description = '[landing] general_a11y_descriotion' } } = nls();
    const markComplete = () => {
        landingChange({ complete: true });
        publish('active-view', 'assess');
    };
    const button = w(Button, {
        onClick: markComplete
    }, [{ label: general_complete_button }]);
    const content = v('div', { classes: [themeCss.root] }, [
        useResourceParsing
            ? w(ResourceParser, { topicid: 'general_content', messages: { default: general_content } })
            : v('div', { innerHTML: general_content }),
        useDialog ? null : button
    ]);
    documentapi.setTitle(general_a11y_description);
    return useDialog
        ? w(Dialog, { open: true, underlay: true, closeable: true, onRequestClose: markComplete }, [{ content }])
        : content;
});
registry.define('LandingPageGeneral', GeneralLandingPage);
export default GeneralLandingPage;
